import { UseQueryState } from 'urql';

import { CartQuery } from '__generated__/graphql';

export const isCartInStock = (cartResult: UseQueryState<CartQuery>) => {
  // If the cart is fetching or has errored then we
  // don't know for sure that all items in the cart are in stock
  if (cartResult.fetching || cartResult.error) return false;
  // Check that every item is either a gift card or a product
  // where the inventory is greater than or equal to
  // the quantity of that product in the cart

  return cartResult.data?.activeCart?.products?.every(item => {
    return (
      item.__typename === 'GiftCardCartItem' ||
      (item.__typename === 'ProductCartItem' && item.hasStock)
    );
  });
};
